import { useEffect, useState } from "react";
import { Button, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Confirmmodal from "../../User/components/Confirm_modal";
import { useGlobalContext } from "../../context/Context";
import instance from "../../Utils/api";
import { toast } from "react-toastify";
import Login from "../components/Login";

const ProceedToWatsapp = ({ isWatsapp, handleWatsappCloseModal }) => {
  const { userName } = useGlobalContext();
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [isBookingTriggered, setBookingTriggered] = useState(false);
  const [name, setName] = useState();
  const [phone, setPhone] = useState();
  const [reason, setReason] = useState();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (userName) {
      setPhone(userName.mobile)
      setName(userName.name)
    }
  }, [userName]);

  const handleCloseLoginModal = () => {
    setLoginModalOpen(false);
  };

  const handleLoginSuccess = () => {
    setLoginModalOpen(false);
    setBookingTriggered(true);
  };

  const handleBook = async () => {
    if (!token) {
      setLoginModalOpen(true);
      return;
    }

    if (!name || !phone || !reason) {
      return toast.error("Please fill all required Fields")
    }

    try {
      const response = await instance.post("/Consultation/raiseConsultation", {
        name,
        phone,
        reason
      });
      if (response.data.success === true) {
        toast.success(response.data.message);
        setReason("");
        await handleWatsappCloseModal();

        setTimeout(() => {
          sendWhatsAppMessage(
            "+919036074200",
            `Hello! My name is ${name}, and I am looking for ${reason}.`
          );
        }, 1500);
      } else {
        setReason("");
        await handleWatsappCloseModal();
        toast.error(response.data.message);
      }
    } catch (error) {
      setReason("");
      await handleWatsappCloseModal();
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };


  if (isBookingTriggered) {
    handleBook();
    setBookingTriggered(false);
  }

  const sendWhatsAppMessage = (phoneNumber, message) => {
    const whatsappUrl = `https://wa.me/${phoneNumber.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };


  return (
    <>
      <Confirmmodal isOpen={isWatsapp} onClose={handleWatsappCloseModal}>
        <section className="proceed-whatsapp">
          <div className="proceed-whatsapp-content">
            <div className="proceed-whatsapp-text">
              <Typography variant="h4">Talk To Our Expert Designer</Typography>
              <Typography variant="h6">
                Hi {userName?.name}, please confirm to proceed. Let me know when
                you're ready!
              </Typography>
            </div>
            <div className="consultation_popup">
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                  <div className="admin-textfiled">
                    <TextField
                      placeholder="Enter your full name"
                      label="Full name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      type="text"
                      fullWidth
                      required
                    />
                  </div>
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                  <div className="admin-textfiled">
                    <TextField
                      placeholder="Enter your Mobile Number"
                      label="Mobile Number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      type="text"
                      fullWidth
                      required
                    />
                  </div>
                </Grid>
                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                  <div className="admin-textarea">
                    <TextField
                      placeholder="Enter What you are looking for"
                      label="What you are looking for"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      fullWidth
                      required
                      multiline
                      rows={3}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
            <div className="proceed-whatsapp-btns">
              <Button
                className="proceed-btn-cancel"
                onClick={handleWatsappCloseModal}
              >
                Cancel
              </Button>
              <Button className="proceed-btn-add" onClick={handleBook}>
                Book Our Expert
              </Button>
            </div>
          </div>
        </section>
      </Confirmmodal>

      {isLoginModalOpen && (
        <Login
          isLoginModalOpen={isLoginModalOpen}
          handleCloseLoginModal={handleCloseLoginModal}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </>
  );
};

export default ProceedToWatsapp;
